import { render, staticRenderFns } from "./ExchangeRate.vue?vue&type=template&id=90c0e51c&scoped=true"
var script = {}
import style0 from "./ExchangeRate.vue?vue&type=style&index=0&id=90c0e51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c0e51c",
  null
  
)

export default component.exports